import 'amfe-flexible';
import Vue from 'vue';
import App from './App';
import { router } from './router';
import { Tab, Tabs } from 'vant';

Vue.use(Tab).use(Tabs);
Vue.prototype.navigator = data => {
    router.push(data)
}
new Vue({
    router,
    el: '#app',
    render: h => h(App)
});
